import React, { useEffect, useState } from "react";
import Admin from "./admin/Admin";
import Support from "./support/Support";

export default function Dashboard() {
    const [role, setRole] = useState(localStorage.getItem("role"));

    useEffect(() => {
        // В случае, если роль может меняться, можно добавить подписку
        const handleStorageChange = () => {
            setRole(localStorage.getItem("role"));
        };

        window.addEventListener("storage", handleStorageChange);
        return () => {
            window.removeEventListener("storage", handleStorageChange);
        };
    }, []);

    if (!role) {
        return <div>Loading...</div>; // Можно вернуть индикатор загрузки, если роль отсутствует
    }

    switch (role) {
        case "CardList":
            return <Admin />;
        case "support":
            return <Support />;
        default:
            return <Admin />;
    }
}
